import React from "react";
import TextWImage from "@/library/components/texts/TextWImage";
import { cn } from "@/storyblok/utils/cn";
import Title from "./Title";

export default function TextWImageSection({ blok }) {
  const {
    title,
    titleAs = "h1",
    titleColor,
    subTitle,
    subTitleColor = "secondary-accent",
    backgroundColor,
    contentBlocks,
  } = blok;

  const backgroundClasses = cn("px-8 py-16 md:px-0 md:w-full ", {
    "bg-bg-color-white": backgroundColor === "bg-white",
    "bg-bg-color-light": backgroundColor === "bg-light",
    "bg-bg-color-dark": backgroundColor === "bg-dark",
    "bg-bg-color-grey": backgroundColor === "bg-grey",
    "bg-bg-color-orange": backgroundColor === "bg-orange",
  });

  const subTitleAs = titleAs === "h1" ? "h2" : titleAs === "h2" ? "h3" : "h4";

  return (
    <section className={backgroundClasses}>
      <Title
        title={title}
        titleColor={titleColor}
        titleAs={titleAs}
        className={"text-center mb-2"}
      />
      {subTitle && (
        <Title
          title={subTitle}
          titleColor={subTitleColor}
          titleAs={subTitleAs}
          className={"text-center mb-20"}
        />
      )}
      <div className="flex flex-col items-center gap-8 md:gap-0">
        {contentBlocks.map((block) => (
          <TextWImage
            key={block._uid}
            text={block.text}
            image={block.image}
            textColor={block.textColor}
            imagePosition={block.imagePosition}
            backgroundColor={block.backgroundColor}
          />
        ))}
      </div>
    </section>
  );
}

// lg:max-w-7xl
